/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DidDocumentVerificationMethodItem } from './DidDocumentVerificationMethodItem';
import { Service } from './Service';

export const DidDocument: core.serialization.ObjectSchema<serializers.DidDocument.Raw, Truvity.DidDocument> =
    core.serialization.object({
        context: core.serialization.property('@context', core.serialization.list(core.serialization.string())),
        assertionMethod: core.serialization.list(core.serialization.string()),
        authentication: core.serialization.list(core.serialization.string()),
        id: core.serialization.string(),
        service: core.serialization.list(Service),
        verificationMethod: core.serialization.list(DidDocumentVerificationMethodItem),
    });

export declare namespace DidDocument {
    export interface Raw {
        '@context': string[];
        assertionMethod: string[];
        authentication: string[];
        id: string;
        service: Service.Raw[];
        verificationMethod: DidDocumentVerificationMethodItem.Raw[];
    }
}
